// Utils
import { post } from '@/utils/client';

// Hooks
import useToastsNotifications from '@/utils/hooks/swr/notifications/useToastsNotifications';

// Lib
import {
    COLLABORATION_NOTIFICATIONS_MARK_AS_READ,
    NOTIFICATIONS_MARK_AS_READ
} from '@/lib/routes/apiEndpoints';

// Types
import type {
    NotificationCollaborationType,
    NotificationIdType
} from '@/hooks/context/toast/types';

const useMarkAsReadNotification = () => {
    const { hasUnreadNotifications, mutateToastsNotifications } = useToastsNotifications({
        revalidateOnMount: false,
        shouldRetryOnError: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false
    });

    const markAsRead = (notificationId: NotificationIdType) => {
        if (typeof notificationId === 'string' && notificationId.split('-')[0] !== 'toast') {
            try {
                post(NOTIFICATIONS_MARK_AS_READ, {
                    notifications_ids: [notificationId]
                });
            } catch (e) {
                // No error catch
            }

            if (hasUnreadNotifications) {
                mutateToastsNotifications(
                    (prevState) => ({
                        ...prevState,
                        data: {
                            ...prevState.data,
                            total_unread: prevState?.data?.total_unread - 1
                        }
                    }),
                    false
                );
            }
        }
    };

    const markAsReadCollaborationNotification = (notification: NotificationCollaborationType) => {
        if (!notification?.read) {
            const collaborationNotificationId = notification?.data?.notification_sibling_id;

            if (collaborationNotificationId) {
                try {
                    post(COLLABORATION_NOTIFICATIONS_MARK_AS_READ, {
                        ids: [collaborationNotificationId]
                    });
                } catch (e) {
                    // No error to catch
                }
            }
        }
    };

    return {
        markAsRead,
        markAsReadCollaborationNotification
    };
};

export default useMarkAsReadNotification;
